import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import Auth from './pages/Auth/Auth';
import ForgotPassword from './pages/Auth/ForgotPassword';
import Dashboard from './pages/Dashboard/Dashboard';
import BaziInput from './pages/BaziInput/BaziInput';
import BaziDetail from './pages/BaziDetail/BaziDetail';
import Community from './pages/Community/Community';
import './App.css';
import Profile from './pages/Profile/Profile';
import UserProfile from './pages/UserProfile/UserProfile';
import AdminUsers from './pages/Admin/Users';
import AdminLabels from './pages/Admin/Labels';
import AdminGroups from './pages/Admin/Groups';
import AlmanacPage from './pages/Almanac/Almanac';

// 私有路由组件
const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <div className="loading">加载中...</div>;
  }
  
  return user ? children : <Navigate to="/auth" />;
};

function App() {
  return (
    <ThemeProvider>
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/auth" element={<Auth />} />
            <Route path="/auth/forgot" element={<ForgotPassword />} />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/bazi/new"
              element={
                <PrivateRoute>
                  <BaziInput />
                </PrivateRoute>
              }
            />
            <Route
              path="/bazi/:id"
              element={
                <PrivateRoute>
                  <BaziDetail />
                </PrivateRoute>
              }
            />
            <Route
              path="/community"
              element={
                <PrivateRoute>
                  <Community />
                </PrivateRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <PrivateRoute>
                  <Profile />
                </PrivateRoute>
              }
            />
            <Route
              path="/users/:id"
              element={
                <PrivateRoute>
                  <UserProfile />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/users"
              element={
                <PrivateRoute>
                  <AdminUsers />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/labels"
              element={
                <PrivateRoute>
                  <AdminLabels />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/groups"
              element={
                <PrivateRoute>
                  <AdminGroups />
                </PrivateRoute>
              }
            />
            <Route
              path="/almanac"
              element={
                <PrivateRoute>
                  <AlmanacPage />
                </PrivateRoute>
              }
            />
            <Route path="/" element={<Navigate to="/dashboard" />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
    </ThemeProvider>
  );
}

export default App;

